import { BaseService } from "services/_baseService";
import appAxios from "services/axios";

export const TOUR_PACKAGE_STATUS = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
  ARCHIVED: 'ARCHIVED',
  IN_REVIEW: 'IN_REVIEW',
}
class TourPackagesService extends BaseService<any> {
  constructor() {
    super(`tour-packages`);
  }
  uploadImages = async (id: number, formData: FormData) => {
    return appAxios.post(`${this.pathWithOrg()}/${id}/media`, formData);
  };
  archive = async (id: number) => {
    return appAxios.post(`${this.pathWithOrg()}/${id}/archive`);
  };
}

export default new TourPackagesService();
